import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import '../assets/css/main.css';
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import { Link } from "react-router-dom";

const Contact = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contact: "",
    subject: "",
    message: "",
  });

  const [status, setStatus] = useState({ loading: false, success: false, error: false });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, success: false, error: false });

    try {
      const response = await fetch(
        "https://script.google.com/macros/s/AKfycby9XJW_dYqE6BiGS2UnA0KpW0N3Y8se6174Dmu-U989fptRudUATBOzeeWcXi-0zOGC/exec",
        {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: `Name=${formData.name}&Email=${formData.email}&Contact=${formData.contact}&Subject=${formData.subject}&Message=${formData.message}`,
        }
      ).then((res) => res.text())
        .then((data) => {
          let timerInterval;
          Swal.fire({
            title: `Message Sent Successfully!`,
            icon: 'success',
            html: "Autoclose in <b></b> milliseconds.",
            timer: 3000,
            timerProgressBar: true,
            didOpen: () => {
              Swal.showLoading();
              const timer = Swal.getPopup().querySelector("b");
              timerInterval = setInterval(() => {
                timer.textContent = `${Swal.getTimerLeft()}`;
              }, 100);
            },
            willClose: () => {
              clearInterval(timerInterval);
            }

          }).then((result) => {
            if (result.dismiss === Swal.DismissReason.timer) {
              console.log("");
            }
          });
          setStatus({ loading: false, success: true, error: false });
          setFormData({ name: "", email: "", subject: "", message: "" });
        })
        .catch((error) => {
          console.error("Error:", error);
          Swal.fire({
            icon: "error",
            title: "Oops!",
            text: "Something went wrong. Please try again later.",
            footer: '<a href="mailto:support@example.com">Need help? Contact support</a>',
          });
          setStatus({ loading: false, success: false, error: true });
        });
    } catch (error) {
      console.error("Submission error:", error);
      Swal.fire({
        icon: "error",
        title: "Oops!",
        text: "Something went wrong. Please try again later.",
        footer: '<a href="mailto:support@example.com">Need help? Contact support</a>',
      });
      setStatus({ loading: false, success: false, error: true });
    }
  };

  return (
    <section id="contact" className="contact section">
      <div className="container section-title" data-aos="fade-up">
        <h2>Contact</h2>
        <p>Contact us now to get expert career guidance</p>
      </div>

      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <div className="row g-4 g-lg-5">
          <div className="col-lg-5">
            <div className="info-box " data-aos="fade-up" data-aos-delay="200">
              <h3>Contact Info</h3>
              <p>We'd love to hear from you! Whether you have questions, feedback, or inquiries, feel free to reach out to us.</p>

              <div className="info-item" data-aos="fade-up" data-aos-delay="300">
                <div className="icon-box">
                  <i className="bi bi-geo-alt"></i>
                </div>
                <div className="content">
                  <h4>Our Locations</h4>
                  <p style={{textAlign : "justify"}}><strong>( Head Quarter ) Tamil Nadu</strong> - MyCareergems EduTech - Door No. 43, Plot No. 18, Madurai Meenakshipuram, Urapakkam, Chengalpattu, Tamil Nadu - 603210</p>
                  <p><strong>Contact : </strong>+91 744 920 6853</p>

                  <Link to="/locations" className="text">
                    <strong>View Other Locations</strong>
                  </Link>

                  {/* <hr></hr>
                  <p style={{textAlign : "justify"}}><strong>Arunachal Pradesh </strong> - upGRADE Academy Education Consultancy - Landmark - opp. National Public School, A-sector, Nyigam colony, Town- Naharlagun, Dist. Papum Pare, Arunachal Pradesh - 791110</p>
                  <p><strong>Contact : </strong>+91 996 283 2087</p> */}
                </div>
              </div>
              <div className="info-item" data-aos="fade-up" data-aos-delay="400">
                <div className="icon-box">
                  <i className="bi bi-telephone"></i>
                </div>
                <div className="content">
                  <h4>Phone Number</h4>
                  <p>+91 744 920 6853</p>
                  <p>+91 996 283 2087</p>
                </div>
              </div>

              <div className="info-item" data-aos="fade-up" data-aos-delay="500">
                <div className="icon-box">
                  <i className="bi bi-envelope"></i>
                </div>
                <div className="content">
                  <h4>Email Address</h4>
                  <p>support@mycareergems.com</p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-7">
            <div className="contact-form" data-aos="fade-up" data-aos-delay="300">
              <h3>Get In Touch</h3>
              <p>Alternatively, you can fill out the contact form below, and we'll get back to you as soon as possible!.</p>

              <form onSubmit={handleSubmit} className="php-email-form">
                <div className="row gy-4">
                  <div className="col-md-6">
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="Your Name"
                      value={formData.name}
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                      required
                    />
                  </div>

                  <div className="col-md-6">
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder="Your Email"
                      value={formData.email}
                      onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                      required
                    />
                  </div>


                  <div className="col-md-6">
                    <input
                      type="contact"
                      name="contact"
                      className="form-control"
                      placeholder="Your Contact"
                      value={formData.contact}
                      onChange={(e) => setFormData({ ...formData, contact: e.target.value })}
                      required
                    />
                  </div>

                  <div className="col-12">
                    <input
                      type="text"
                      name="subject"
                      className="form-control"
                      placeholder="Subject"
                      value={formData.subject}
                      onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
                      required
                    />
                  </div>

                  <div className="col-12">
                    <textarea
                      name="message"
                      className="form-control"
                      rows="6"
                      placeholder="Message"
                      value={formData.message}
                      onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                      required
                    ></textarea>
                  </div>

                  <div className="col-12 text-center">
                    {status.loading && <div className="loading">Loading...</div>}
                    {status.error && <div className="error-message">Something went wrong. Please try again.</div>}
                    {status.success && <div className="sent-message">Your message has been sent. Thank you!</div>}

                    <button type="submit" className="btn" disabled={status.loading}>
                      {status.loading ? (
                        <span className="spinner"></span>
                      ) : (
                        "Send Message"
                      )}
                    </button>

                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;